<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="Returns">
      <div class="main-content">
        <div class="page-width">
          <div class="section-header text-center">
            <h1>Returns and Refunds</h1>
          </div>
          <div class="rte">
            <h5>
              <span class="underlined-font"><b>Refund Policy</b></span>
            </h5>
            <p><span class="rail-font">A refund, or credit, for the cost of unopened merchandise, less a 15% restocking fee, will be issued when merchandise is returned within 10 days of receipt. Shipping cost will only be refunded if the return is due to an error made by Asian Food Grocer (AFG).</span></p>
            <p><span class="rail-font">Please note: AFG is not responsible for items opened or damaged due to high pressure/altitude. These items will not be refunded or accepted for return.</span></p>
            <p><span class="rail-font">Out of Stock Items</span></p>
            <p><span class="rail-font">Due to AFG's large variety of items and constant volume of sales, occasionally, items listed for sale on the e-store may be out of stock. &nbsp;AFG will issue an immediate refund for items ordered but currently not in stock.</span></p>
            <h5>
              <b><span style="text-decoration: underline;">Return Policy</span><br></b><b></b>
            </h5>
            <h5><b>Products Damaged, Shipped in Error, or Not Received</b></h5>
            <p><span class="rail-font">Products are free of damage and breakage when your order is shipped from our warehouses. Although AFG products are packaged very carefully, damages may occur in transit or products may not reach their final destination. Please contact Customer Service if you receive a damaged or broken product, or if you have not received your order. You will be asked to provide proof by photo to info@asianfoodgrocer.com along with your order number attached, via email.</span></p>
            <p><span class="rail-font">Make sure to save all contents, including packaging, for FedEx to investigate on any damaged order. AFG will then submit a claim to the carrier for their investigation. The investigation may take up to two business weeks to complete. Replacement items will not be shipped until the claim process has been resolved.</span></p>
            <p><span class="rail-font">Shipping charges on the original order will be refunded or a credit given only if the merchandise is damaged in transit or was shipped in error.</span></p>
            <h5><span class="underlined-font"><b>Unopened Merchandise</b></span></h5>
            <p><span class="rail-font">Unopened merchandise may be returned within 10 days of receipt. Return shipping charges will be the customer’s responsibility. Returned items will be subject to a 15% restocking fee and original shipping charges will not be refunded.</span></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '../components/breadcrumb'

export default {
  name: "returns",
  components: {
    breadcrumb,
  },
  data() {
    return {
      path2: 'Returns and Refunds',
    }
  },
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/returns.less";
</style>



// WEBPACK FOOTER //
// src/view/returnsAndRefunds.vue